/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const WebhookClusterGwLogicalBackupPost = {
  id: 'webhook.cluster-gw.logical-backup.post',
  tag: 'Webhook',
  summary: 'Handle ClusterGW Logical Backup',
  description: 'Handle ClusterGW Logical Backup',
  method: 'post',
  route: () => `/webhook/clustergw/backup/logical`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            workspace_id: z.string().min(1),
            customer_id: z.number().positive(),
            cluster_id: z.number().positive(),
            result: z.enum(['Complete', 'Failed']),
            job_name: z.string().min(1),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
